import { ProtocolPdfResultDto } from './ProtocolPdfResultDto';

export class ProtocolPdfAggregatedResultDto extends ProtocolPdfResultDto {
  public results: ProtocolPdfResultDto[] | undefined;
}
